import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface NhanSuState {
  hoSoList?: any
  giaDinhList?: any
  taiLieuList?: any
  hopDongList?: any
  khenThuongKyLuatList?: any
  baoHiemList?: any
  duLieuThamChieuList?: any
  thongTinKhacList?: any
  thaoTacHangLoatList?: any
  xuatNhapList?: any
  phongBanList?: any
  chucVuList?: any
  reloadNhanSuList?: string | null
}

const initialState: NhanSuState = {
  hoSoList: initialDataList,
  giaDinhList: initialDataList,
  taiLieuList: initialDataList,
  hopDongList: initialDataList,
  khenThuongKyLuatList: initialDataList,
  baoHiemList: initialDataList,
  duLieuThamChieuList: initialDataList,
  thongTinKhacList: initialDataList,
  thaoTacHangLoatList: initialDataList,
  xuatNhapList: initialDataList,
  phongBanList: initialDataList,
  chucVuList: initialDataList,
  reloadNhanSuList: null,
}

export const nhanSuDucks = createSlice({
  name: 'nhanSu',
  initialState,
  reducers: {
    // Hồ sơ
    layDanhSachHoSo: (state: RootState, action: PayloadAction<any>) => {
      state.hoSoList = { loading: true, queryStr: action.payload }
    },
    layDanhSachHoSoThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.hoSoList = { loading: false, ...action.payload }
    },
    layDanhSachHoSoThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.hoSoList = { loading: false, ...action.payload }
    },

    // Gia đình
    layDanhSachGiaDinh: (state: RootState, action: PayloadAction<any>) => {
      state.giaDinhList = { loading: true, queryStr: action.payload }
    },
    layDanhSachGiaDinhThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.giaDinhList = { loading: false, ...action.payload }
    },
    layDanhSachGiaDinhThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.giaDinhList = { loading: false, ...action.payload }
    },

    // Tài liệu
    layDanhSachTaiLieu: (state: RootState, action: PayloadAction<any>) => {
      state.taiLieuList = { loading: true, queryStr: action.payload }
    },
    layDanhSachTaiLieuThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.taiLieuList = { loading: false, ...action.payload }
    },
    layDanhSachTaiLieuThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.taiLieuList = { loading: false, ...action.payload }
    },

    // Hợp đồng
    layDanhSachHopDong: (state: RootState, action: PayloadAction<any>) => {
      state.hopDongList = { loading: true, queryStr: action.payload }
    },
    layDanhSachHopDongThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.hopDongList = { loading: false, ...action.payload }
    },
    layDanhSachHopDongThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.hopDongList = { loading: false, ...action.payload }
    },

    // Khen thưởng & Kỷ luật
    layDanhSachKhenThuongKyLuat: (state: RootState, action: PayloadAction<any>) => {
      state.khenThuongKyLuatList = { loading: true, queryStr: action.payload }
    },
    layDanhSachKhenThuongKyLuatThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.khenThuongKyLuatList = { loading: false, ...action.payload }
    },
    layDanhSachKhenThuongKyLuatThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.khenThuongKyLuatList = { loading: false, ...action.payload }
    },

    // Bảo hiểm
    layDanhSachBaoHiem: (state: RootState, action: PayloadAction<any>) => {
      state.baoHiemList = { loading: true, queryStr: action.payload }
    },
    layDanhSachBaoHiemThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.baoHiemList = { loading: false, ...action.payload }
    },
    layDanhSachBaoHiemThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.baoHiemList = { loading: false, ...action.payload }
    },

    // Dữ liệu tham chiếu
    layDanhSachDuLieuThamChieu: (state: RootState, action: PayloadAction<any>) => {
      state.duLieuThamChieuList = { loading: true, queryStr: action.payload }
    },
    layDanhSachDuLieuThamChieuThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.duLieuThamChieuList = { loading: false, ...action.payload }
    },
    layDanhSachDuLieuThamChieuThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.duLieuThamChieuList = { loading: false, ...action.payload }
    },

    // Thông tin khác
    layDanhSachThongTinKhac: (state: RootState, action: PayloadAction<any>) => {
      state.thongTinKhacList = { loading: true, queryStr: action.payload }
    },
    layDanhSachThongTinKhacThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.thongTinKhacList = { loading: false, ...action.payload }
    },
    layDanhSachThongTinKhacThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.thongTinKhacList = { loading: false, ...action.payload }
    },

    // Thao tác hàng loạt
    layDanhSachThaoTacHangLoat: (state: RootState, action: PayloadAction<any>) => {
      state.thaoTacHangLoatList = { loading: true, queryStr: action.payload }
    },
    layDanhSachThaoTacHangLoatThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.thaoTacHangLoatList = { loading: false, ...action.payload }
    },
    layDanhSachThaoTacHangLoatThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.thaoTacHangLoatList = { loading: false, ...action.payload }
    },

    // Xuất nhập
    layDanhSachXuatNhap: (state: RootState, action: PayloadAction<any>) => {
      state.xuatNhapList = { loading: true, queryStr: action.payload }
    },
    layDanhSachXuatNhapThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.xuatNhapList = { loading: false, ...action.payload }
    },
    layDanhSachXuatNhapThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.xuatNhapList = { loading: false, ...action.payload }
    },

    // Phòng ban
    layDanhSachPhongBan: (state: RootState) => {
      state.phongBanList = { loading: true }
    },
    layDanhSachPhongBanThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.phongBanList = { loading: false, ...action.payload }
    },
    layDanhSachPhongBanThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.phongBanList = { loading: false, ...action.payload }
    },

    // Chức vụ
    layDanhSachChucVu: (state: RootState) => {
      state.chucVuList = { loading: true }
    },
    layDanhSachChucVuThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.chucVuList = { loading: false, ...action.payload }
    },
    layDanhSachChucVuThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.chucVuList = { loading: false, ...action.payload }
    },

    datTaiLaiDanhSachNhanSu: (state: RootState) => {
      state.reloadNhanSuList = String(Date.now())
    },
  },
})

export const {
  layDanhSachHoSo,
  layDanhSachHoSoThanhCong,
  layDanhSachHoSoThatBai,
  layDanhSachGiaDinh,
  layDanhSachGiaDinhThanhCong,
  layDanhSachGiaDinhThatBai,
  layDanhSachTaiLieu,
  layDanhSachTaiLieuThanhCong,
  layDanhSachTaiLieuThatBai,
  layDanhSachHopDong,
  layDanhSachHopDongThanhCong,
  layDanhSachHopDongThatBai,
  layDanhSachKhenThuongKyLuat,
  layDanhSachKhenThuongKyLuatThanhCong,
  layDanhSachKhenThuongKyLuatThatBai,
  layDanhSachBaoHiem,
  layDanhSachBaoHiemThanhCong,
  layDanhSachBaoHiemThatBai,
  layDanhSachDuLieuThamChieu,
  layDanhSachDuLieuThamChieuThanhCong,
  layDanhSachDuLieuThamChieuThatBai,
  layDanhSachThongTinKhac,
  layDanhSachThongTinKhacThanhCong,
  layDanhSachThongTinKhacThatBai,
  layDanhSachThaoTacHangLoat,
  layDanhSachThaoTacHangLoatThanhCong,
  layDanhSachThaoTacHangLoatThatBai,
  layDanhSachXuatNhap,
  layDanhSachXuatNhapThanhCong,
  layDanhSachXuatNhapThatBai,
  layDanhSachPhongBan,
  layDanhSachPhongBanThanhCong,
  layDanhSachPhongBanThatBai,
  layDanhSachChucVu,
  layDanhSachChucVuThanhCong,
  layDanhSachChucVuThatBai,
  datTaiLaiDanhSachNhanSu,
} = nhanSuDucks.actions

export default nhanSuDucks.reducer
